module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-8.84e86351.png";